// src/data/comedians/gad-elmaleh.js

const base = {
  id: 'gad-elmaleh',
  slug: 'gad-elmaleh',
  name: 'Gad Elmaleh',
  birthYear: 1971,
  image: require('@/assets/images/img_Gad_Elmaleh.jpg'),
  famousWorks: [
    "L'autre c'est moi",
    'La Vie normale',
    'Papa est en haut',
    "D'ailleurs",
    'Chouchou',
    'Coco',
  ],
};

export default [
  {
    ...base,
    lang: 'en',
    nationality: 'Moroccan-French',
    shortBio: 'One of the most influential modern Moroccan-French comedians',
    bio: `Gad Elmaleh is one of the most popular and influential French comedians of modern times. He played a key role in bringing contemporary stand-up comedy to mainstream audiences in France, making him a pivotal figure in the French comedy scene.\n\nBorn in Casablanca, Morocco, Elmaleh moved to France where he developed his distinctive comedic voice. His humor focuses on everyday life, family relationships, cultural differences, and personal experiences. Known for his strong storytelling skills and natural stage presence, he appeals to a broad international audience.\n\nElmaleh has also pursued an international career, performing in English and expanding his reach beyond the French-speaking world. Still very active today, he continues to perform live shows in France and abroad, maintaining a strong digital and media presence.`,
    style: 'Observational humor, storytelling, self-deprecation, cultural contrasts',
    achievements: [
      'Multiple sold-out tours',
      'International comedy career',
      'Major figure in French stand-up comedy',
      'Successful film career in France and internationally',
    ],
  },
  {
    ...base,
    lang: 'fr',
    nationality: 'Marocain-Français',
    shortBio: 'L\'un des comédiens franco-marocains les plus influents',
    bio: `Gad Elmaleh est l'un des comédiens français les plus populaires et influents de notre époque. Il a joué un rôle clé dans l'introduction du stand-up contemporain auprès du grand public en France, faisant de lui une figure centrale de la scène comique française.\n\nNé à Casablanca, au Maroc, Elmaleh s'est installé en France où il a développé sa voix comique distinctive. Son humour porte sur la vie quotidienne, les relations familiales, les différences culturelles et les expériences personnelles. Reconnu pour ses qualités de conteur et sa présence naturelle sur scène, il séduit un large public international.\n\nElmaleh a également poursuivi une carrière internationale, se produisant en anglais et élargissant son rayonnement au-delà du monde francophone. Toujours très actif, il continue de se produire en France et à l'étranger.`,
    style: 'Humour observationnel, narration, autodérision, contrastes culturels',
    achievements: [
      'Nombreuses tournées sold-out',
      'Carrière comique internationale',
      'Figure majeure du stand-up français',
      'Carrière cinématographique réussie en France et à l\'international',
    ],
  },
  {
    ...base,
    lang: 'es',
    nationality: 'Marroquí-Francés',
    shortBio: 'Uno de los comediantes franco-marroquíes más influyentes',
    bio: `Gad Elmaleh es uno de los comediantes franceses más populares e influyentes de los tiempos modernos. Jugó un papel clave en llevar el stand-up contemporáneo al público general en Francia, convirtiéndolo en una figura central de la escena cómica francesa.\n\nNacido en Casablanca, Marruecos, Elmaleh se mudó a Francia donde desarrolló su voz cómica distintiva. Su humor se centra en la vida cotidiana, las relaciones familiares, las diferencias culturales y las experiencias personales. Conocido por sus habilidades narrativas y su presencia natural en el escenario, atrae a un amplio público internacional.\n\nElmaleh también ha perseguido una carrera internacional, actuando en inglés y expandiendo su alcance más allá del mundo francófono. Todavía muy activo, continúa realizando espectáculos en Francia y en el extranjero.`,
    style: 'Humor observacional, narración, autodesprecio, contrastes culturales',
    achievements: [
      'Múltiples giras agotadas',
      'Carrera cómica internacional',
      'Figura principal del stand-up francés',
      'Exitosa carrera cinematográfica en Francia e internacionalmente',
    ],
  },
  {
    ...base,
    lang: 'ar',
    nationality: 'مغربي-فرنسي',
    shortBio: 'أحد أكثر الكوميديين المغاربة-الفرنسيين تأثيرًا',
    bio: `غاد المالح أحد أكثر الكوميديين الفرنسيين شعبيةً وتأثيرًا في العصر الحديث. أدّى دورًا محوريًا في تقديم الستاند أب المعاصر إلى الجمهور الواسع في فرنسا، ما جعله شخصية محورية في المشهد الكوميدي الفرنسي.\n\nوُلد في الدار البيضاء بالمغرب وانتقل إلى فرنسا حيث طوّر صوته الكوميدي المميز. تتمحور فكاهته حول الحياة اليومية والعلاقات الأسرية والاختلافات الثقافية والتجارب الشخصية. يتميز بمهارات قصصية متميزة وحضور طبيعي على الخشبة يجذب جمهورًا دوليًا واسعًا.\n\nسعى المالح أيضًا إلى مسيرة دولية يؤدي فيها بالإنجليزية، موسّعًا نطاق وصوله إلى ما هو أبعد من العالم الناطق بالفرنسية. لا يزال نشطًا جدًا اليوم ويواصل الأداء في فرنسا وخارجها.`,
    style: 'فكاهة ملاحظاتية، رواية قصصية، استهزاء بالنفس، تباينات ثقافية',
    achievements: [
      'جولات متعددة بطاقة كاملة',
      'مسيرة كوميدية دولية',
      'شخصية بارزة في الستاند أب الفرنسي',
      'مسيرة سينمائية ناجحة في فرنسا وعالميًا',
    ],
  },
];
